import React from 'react'
import PropTypes from 'prop-types'
import {statusTypes} from 'ag-common/tools/fileStatus'
import {Link} from 'react-router-dom'
import actions from 'redux-auto'
import NavAusbildungsnachweise from '#components/svg/icons/NavAusbildungsnachweise'
import NavAusbildungsplan from '#components/svg/icons/NavAusbildungsplan'
import NavMeineAzubis from '#components/svg/icons/NavMeineAzubis'
import NavMeineAusbildung from '#components/svg/icons/NavMeineAusbildung'
import NavStatusUebersicht from '#components/svg/icons/NavStatusUebersicht'
import NavVersetzungsplan from '#components/svg/icons/NavVersetzungsplan'
import NavWissensPortal from '#components/svg/icons/NavWissensPortal'
import NavFeedback from '#components/svg/icons/NavFeedback'
import {usePermissions} from '#hooks/usePermissions'

function MenuItem({url, text, lead, active, hasSubmittedChapter, disabled = false}) {
  const permissions = usePermissions()

  const className = active ? 'menu__link active' : 'menu__link'
  let modifer = ''
  if (hasSubmittedChapter && permissions.ausbildungsplan.verify) {
    modifer += `menu__link--${statusTypes.submitted}`
  }

  const id = url ? `menu_item_${extractIdOfMenuItem(url)}` : undefined

  const inner = (
    <>
      {lead && (
        <span className="menu__item__cat">
          {lead}
          <br />
        </span>
      )}
      {renderIcon(url)}
      <span data-testid="menu-item-text" className="menu__item__text">
        {text}
      </span>
    </>
  )
  if (!disabled) {
    return (
      <Link to={url} id={id} className={`${className} ${modifer}`} onClick={() => closeMobileMenu(url)}>
        {inner}
      </Link>
    )
  }
  return (
    <span id={id} className={`${className} ${modifer} disabled`}>
      {inner}
    </span>
  )
}

const closeMobileMenu = url => {
  const isAusbildungsplan = url.includes('ausbildungsplan')
  const isAusbildungsplanContent = isAusbildungsplan && url.includes('static')

  if (!isAusbildungsplan || isAusbildungsplanContent) {
    actions.mobileMenu.closeMenu()
  }
}

function extractIdOfMenuItem(url) {
  const replacedFirstSlash = url.replace('/', '')
  return replacedFirstSlash.replace('/', '-')
}

const findTerm = (url, term) => {
  if (url && url.includes(term)) {
    return url
  }
  return false
}

function renderIcon(url) {
  switch (url) {
    case '/meineausbildung':
      return <NavMeineAusbildung />
    case '/uebersicht':
      return <NavMeineAusbildung />
    case findTerm(url, '/meineazubis'):
      return <NavMeineAzubis />
    case '/ausbildungsnachweise':
      return <NavAusbildungsnachweise />
    case '/ausbildungsplan':
      return <NavAusbildungsplan />
    case '/ablaufundtermine':
      return <NavVersetzungsplan />
    case '/praxisaufgabenOverview':
      return <NavStatusUebersicht />
    case '/next':
      return <NavWissensPortal />
    case '/feedback':
      return <NavFeedback />
    default:
      return null
  }
}

MenuItem.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string.isRequired,
  active: PropTypes.bool,
  lead: PropTypes.string,
  hasSubmittedChapter: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default MenuItem
